export default "__VITE_ASSET__DCRg7vNn__"